import { createSelector } from '@reduxjs/toolkit';
import trim from 'lodash/trim';
import last from 'lodash/last';
import { getQueryLocation } from 'store/router/routerSelectors';

export const getCountry = createSelector(getQueryLocation, (location) => trim(last((location || '').split(','))) || null);
